import React, { Fragment, useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Navbar from "../../Components/Navbar/Navbar";
import trash from "./../../Assets/Images/trash.png";
import Select from "react-select";
import { Select as SearchBox } from 'antd';
import "./Inventory.css";
import { antdesignSelectStyle, getBranchId, getType, toastStyle } from "../../Helpers/Utils/Common";
import {
  getTransfer,
  createTransfer,
  updateTransfer,
} from "../../Helpers/apiCalls/Inventory/TransferApi";
import { changeRequestStatus } from "../../Helpers/apiCalls/Inventory/RequestsApi";
import { getRequest } from "../../Helpers/apiCalls/Inventory/RequestsApi";
import { getAllItemList } from "../../Helpers/apiCalls/Inventory/ItemListApi";
import { getAllBranches } from "../../Helpers/apiCalls/Purchases/purchaseOrderApi";
import { getAllEmployees } from "../../Helpers/apiCalls/employeesApi";
import { validateTransfer } from "../../Helpers/Validation/Inventory/TransferValidation";
import InputError from "../../Components/InputError/InputError";
import toast from "react-hot-toast";
import Moment from "moment";
import ReactLoading from "react-loading";
import Upload from "antd/es/upload/Upload";
import upload from "../../Assets/Images/upload.png";
import Footer from "../../Components/Footer/Footer";
import { getItemPriceByBranch } from "../../Helpers/apiCalls/Manage/ItemPrice";
/**
 *  COMPONENT: FORM TO ADD OR EDIT PAYMENT
 */
function FormTransfer({ add, edit, request }) {
  const {Dragger} = Upload;
  const accountType = getType();
  const { destination } = useParams();
  const { state } = useLocation();
  const [inactive, setInactive] = useState(true);
  const [showLoader, setShowLoader] = useState(false);
  const { id, type } = useParams();
  let navigate = useNavigate();
  const [isClicked, setIsClicked] = useState(false);
  const [file, setFile] = useState('');
  const [fileList, setFileList] = useState([]);

  // DATA HANDLERS
  const [branchFrom, setBranchFrom] = useState([]);
  const [branchTo, setBranchTo] = useState([]);
  const [allBranches, setAllBranches] = useState([]);
  const [itemOptions, setItemOptions] = useState([]);
  const [filteredItemOptions, setFilteredItemOptions] = useState([]);
  const [items, setItems] = useState([
    {
      entry: {
        name: "item_id",
        label: "",
        value: "",
      },
      prices: 0,
      units: "",
      quantities: "",
    },
    {
      entry: {
        name: "item_id",
        label: "",
        value: "",
      },
      prices: 0,
      units: "",
      quantities: "",
    },
    {
      entry: {
        name: "item_id",
        label: "",
        value: "",
      },
      prices: 0,
      units: "",
      quantities: "",
    },
    {
      entry: {
        name: "item_id",
        label: "",
        value: "",
      },
      prices: 0,
      units: "",
      quantities: "",
    },
    {
      entry: {
        name: "item_id",
        label: "",
        value: "",
      },
      prices: 0,
      units: "",
      quantities: "",
    },
  ]);
  const [employeeOptions, setEmployeeOptions] = useState([]);

  const [newTransfer, setNewTransfer] = useState({
    transfer_date: Moment().format("YYYY-MM-DD"),
    transfer_number: "",
    branch_from: "",
    branch_to: "",
    remarks: "",
    dispatcher: "0",
  });

  const [branchToValue, setBranchToValue] = useState({
    name: "branch_to",
    label: "",
    value: "",
  });
  const [branchFromValue, setBranchFromValue] = useState({
    name: "branch_from",
    label: "",
    value: "",
  });
  const [employeeValue, setEmployeeValue] = useState({
    name: "dispatcher",
    label: "",
    value: "",
  });

  useEffect(() => {
    if (add) {
      fetchAllEmployees();

      const role = getType();
      if (role === "inventory_officer") {
        setBranchFromValue({
          name: "branch_from",
          label: "Warehouse",
          value: 1,
        });
        setNewTransfer((prev) => {
          return { ...prev, branch_from: 1 };
        });
        // fetchAllItems(1);
        fetchBranchToWithoutBranchFrom(1);
      }
      if (role === "commissary_officer") {
        setBranchFromValue({
          name: "branch_from",
          label: "Commissary",
          value: 2,
        });
        setNewTransfer((prev) => {
          return { ...prev, branch_from: 2 };
        });
        // fetchAllItems(2);
        fetchBranchToWithoutBranchFrom(2);
      } else {
        fetchBranches();
      }
    }
  }, []);

  //ERROR HANDLING
  const [isError, setIsError] = useState({
    transfer_date: false,
    transfer_number: false,
    branch_from: false,
    branch_to: false,
    // dispatcher: false,
    listInfo: false,
  });

  // SELECT DROPSEARCH CHANGE HANDLER
  function handleSelectChange(e) {
    const newList = newTransfer;
    newList[e.name] = e.value;
    setNewTransfer(newList);

    if (e.name === "branch_to") {
      setBranchToValue({ name: e.name, label: e.label, value: e.value });
    } else if (e.name === "branch_from") {
      // fetchAllItems(e.value);
      setBranchFromValue({
        name: e.name,
        label: e.label,
        value: e.value,
      });
    } else if (e.name === "dispatcher")
      setEmployeeValue({ name: e.name, label: e.label, value: e.value });
  }
  
  // PAYMENT DETAILS CHANGE HANDLER
  function handlePayChange(e) {
    const { name, value } = e.target;
    const newList = newTransfer;
    newList[name] = value;
    setNewTransfer(newList);
  }

  // ADD ANOTHER INVOICE HANDLER
  function AddItem() {
    const newItem = {
      entry: {
        name: "item_id",
        label: "",
        value: "",
      },
      prices: 0,
      units: "",
      quantities: "",
    };
    setItems((prevItems) => [...prevItems, newItem]);
  }

  // INVOICE CHANGE HANDLER
  function handleItemChange(e, id, type) {
    if (type === "item_id") {
        var temp = items;
        var item_name = itemOptions.filter((data) => {
            return data.value === e
        })
        temp[id].is_old_item = false;
        temp[id].item_id = item_name[0].value;
        temp[id].label = item_name[0].label;
        temp[id].value = item_name[0].value;
        temp[id].item_id_value = { label: item_name[0].label, value: item_name[0].value };
        temp[id].item_units = item_name[0].item_units;
        temp[id].units = item_name[0].item_units[0]?.unit_from;
        temp[id].item_unit_id = item_name[0].item_units[0]?.id;
        temp[id].unit_value = item_name[0].item_units[0]?.unit_from + "|" + item_name[0].item_units[0]?.id;
        setItems(temp);

      // var newItemList = items;
      // var newEntries = newItemList.map((item, index) => {
      //   if (index === id) {
      //     var info = {
      //       name: name,
      //       label: label,
      //       value: value,
      //     };
      //     item.value = value
      //     item.entry = info;
      //     item.prices = prices;
      //     item.item_units = item_units;
      //     item.units = item_units[0]?.unit_from;
      //     item.item_unit_id = item_units[0]?.id;
      //     item.unit_value = item_units[0]?.unit_from + "|" + item_units[0]?.id;
      //     item.current_qty = current_qty;
      //   }
      //   return item;
      // });

      // const filteredOptions = itemOptions.filter(option => {
      //   return !newEntries.find(item => item.value === option.value);
      // });
      // setFilteredItemOptions(filteredOptions);

    } else {
      const {name, value} = e.target
      if (name === "quantities") {
        var newItemList = items;
        var newEntries = newItemList.map((item, index) => {
          if (index === id) {
            item["quantities"] = value;
            if (item.quantities > item.current_qty) {
              toast.error("Quantity Exceeds Current Branch Quantity", {
                style: toastStyle(),
              });
            }
          }
          return item;
        });
        setItems(newEntries);
      } else if (name === "units"){
        var newItemList = items;
        var newEntries = newItemList.map((item, index) => {
          if (index === id) {
            item["unit_value"] = value;
            item["units"] = value.split("|")[0];
            item["item_unit_id"] = value.split("|")[1];
          }
          return item;
        });
        setItems(newEntries);
      }
    }
  }
  

  // INVOICE REMOVAL HANDLER
  function handleRemoveItem(id) {
    const rowId = id;
    const newItemList = [...items];
    newItemList.splice(rowId, 1);
    setItems(newItemList);

    // const filteredOptions = itemOptions.filter(option => {
    //   return !newItemList.find(item => item.value === option.value);
    // });
    // setFilteredItemOptions(filteredOptions);

  }

  //  DISPLAY THE LIST OF ITEMS TABLE
  function renderTable() {
    return (
      <Table className="ps-table">
        <thead>
          <tr>
            <th colSpan={5}>Item</th>
            <th>Quantity</th>
            <th>Unit</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            return (
              <tr key={index}>
                <td colSpan={5} className="select-cell">
                  <SearchBox
                    showSearch
                    value={item.item_id_value}
                    placeholder={"Search Item..."}
                    className="react-select-container w-100"
                    dropdownClassName="z-large antdesign-custom-dropdown"
                    style={antdesignSelectStyle}
                    defaultActiveFirstOption={false}
                    suffixIcon={null}
                    filterOption={false}
                    onSearch={handleSearchItem}
                    onChange={(e) => handleItemChange(e, index, "item_id")}
                    notFoundContent={null}
                    options={(itemOptions || []).map((d) => ({
                    value: d.value,
                    label: d.label,
                    }))}
                  />
                  {/* <Select
                    className="text-start react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select Item..."
                    options={filteredItemOptions}
                    value={item.entry}
                    onChange={(e) => handleItemChange(e, index)}
                  /> */}
                  <InputError
                    isValid={isError.listInfo}
                    message={"Item is required"}
                  />
                </td>
                <td>
                  <Col>
                    <Form.Control
                      type="number"
                      name="quantities"
                      className="hide-spinner numeric-input"
                      value={parseFloat(item.quantities)}
                      // value={parseFloat(item.quantities).toFixed(2)}
                      onChange={(e) => handleItemChange(e, index)}
                    />
                    <InputError
                      isValid={isError.listInfo}
                      message={"Quantity is required"}
                    />
                  </Col>
                </td>
                <td>
                  <Col>
                    {
                      !item.is_old_item ? (
                        <Form.Select
                          name="units"
                          id={item.id}
                          value={item.unit_value}
                          onChange={(e) => handleItemChange(e, index)}
                        >
                          <option value="">Select</option>
                          {item.item_units?.map((data) => {
                            return (
                              <option value={data.unit_from + "|" + data.id}>
                                {data.unit_from}
                              </option>
                            );
                          })}
                        </Form.Select>
                      ) : (
                        <Form.Control
                          type="text"
                          name="units"
                          value={item.units}
                          onChange={(e) => handleItemChange(e, index)}
                        /> 
                      )
                    }
                  </Col>
                </td>
                <td>
                  <img
                    src={trash}
                    onClick={() => handleRemoveItem(index)}
                    className="cursor-pointer"
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }

  const handleSearchItem = (newValue) => {
      if(newValue.length > 2 && newTransfer.branch_from !== "") { //if length of the input is greater than 3, it will call the search api
      handleFetchItems(newValue, setItemOptions);
      }
  };

  // new api for searching items
  async function handleFetchItems(value, setItemOptions) {
    setItemOptions([]);
    const response = await getAllItemList(newTransfer.branch_from, value);
    if (response.data) {
      var itemsList = response.data.data.map((entry) => {
        var info = {};
        info.name = "item_id";
        info.value = entry.item_id;
        info.label = entry.item_name;
        info.entry = {
          name: "item_id",
          value: entry.item_id,
          label: entry.item_name,
        };
        info.unit = entry.unit_to_name;
        info.prices = entry.price;
        info.current_qty = parseInt(entry.current_qty);
        info.item_units = entry.item_units
        return info;
      });
      setItemOptions(itemsList);
    } else {
      response.error?.data?.messages?.map((data) => {
        return toast.error(data, {
          style: toastStyle(),
        });
      })
    }
  }
  
  //  FETCH INVENTORY ITEMS   //
  // async function fetchAllItems(id, items) {
  //   setItemOptions([]);
  //   // setFilteredItemOptions([]);
  //   setShowLoader(true);

  //   // if (edit || request) {
  //     const response = await getAllItemList(id);
  //     if (response.data) {
  //       var itemsList = response.data.data;
  //       var item_options = itemsList.map((entry) => {
  //         var info = {};
  //         info.name = "item_id";
  //         info.value = entry.item_id;
  //         info.label = entry.item_name;
  //         info.entry = {
  //           name: "item_id",
  //           value: entry.item_id,
  //           label: entry.item_name,
  //         };
  //         info.unit = entry.unit_to_name;
  //         info.prices = entry.price;
  //         info.current_qty = parseInt(entry.current_qty);
  //         info.item_units = entry.item_units?.map((data) => {
  //           var info = data
  //           return info
  //         })
  //         return info;
  //       });
  //       setItemOptions(item_options);
  //       // setFilteredItemOptions(item_options);
  //       if(edit || request) {
  //         handleSetItemUnitOption(items, item_options)
  //       }
  //     }
  //   // }
  //   setShowLoader(false);
  // }

  async function fetchBranchToWithoutBranchFrom(branch_id) {
    setBranchTo([]);
    if (add) {
      const response = await getAllBranches();
      if (response) {
        var sortedTo = response.data.data.sort((a, b) =>
          a.name > b.name ? 1 : b.name > a.name ? -1 : 0
        );
        let to = sortedTo.map((a) => {
          return {
            value: a.id,
            label: a.name,
            name: "branch_to",
          };
        });
        setBranchTo(to);
      }
    }
  }

  async function fetchBranches() {
    setAllBranches([]);
    setBranchFrom([]);

    if (add || edit || request) {
      const response = await getAllBranches();

      if (response.data) {
        var sorted_data = response.data.data.sort((a, b) =>
          a.name > b.name ? 1 : b.name > a.name ? -1 : 0
        );
        let all_branches = sorted_data.map((a) => {
          return {
            value: a.id,
            label: a.name,
          };
        });
        setAllBranches(all_branches);

        var branch_from = sorted_data
        .filter((data) => { return data.is_franchise === "3"})
        .map((a) => {
          var info = {};
          info.value = a.id;
          info.label = a.name;
          info.name = "branch_from";
          return info
        });
        setBranchFrom(branch_from);

      }
    }
  }

  // for filtering branch from in branch to options
  useEffect(() => {
    var branch_to = [...allBranches]
    let filtered_branch_to = branch_to
    .filter((data) => {
      return data.value !== newTransfer.branch_from
    })
    .map((a) => {
      return {
        value: a.value,
        label: a.label,
        name: "branch_to",
      };
    });
    if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
        var filteredBranch = filtered_branch_to.filter((data) => {
        return data.value === getBranchId()
        })
        setBranchTo(filteredBranch);
    } else {
        setBranchTo(filtered_branch_to);
    }
  }, [newTransfer.branch_from])

  //API CALL
  async function fetchAllEmployees() {
    setShowLoader(true);
    const response = await getAllEmployees();
    if (response.data.data) {
      var employeesList = response.data.data;
      employeesList.map((employee) => {
        var info = {};

        info.name = "dispatcher";
        info.label = employee.first_name + " " + employee.last_name;
        info.value = employee.id;

        setEmployeeOptions((prev) => [...prev, info]);
      });
    }
    setShowLoader(false);
  }

  async function saveTransfer() {
    if (isClicked) {
      return;
    }
    if (validateTransfer(newTransfer, items, setIsError, "add")) {
      setIsClicked(true);
      newTransfer.attachments = fileList
      const response = await createTransfer(newTransfer, items);
      if (response.data) {
        toast.success(response.data.message, { style: toastStyle() });
        setTimeout(() => {
          navigate(-1);
        }, 1000);
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data);
        })
        setIsClicked(false);
      }
    } else {
      toast.error("Please fill in all required fields", {
        style: toastStyle(),
      });
    }
  }

  /** POST API - SAVE NEW PAYMENT **/
  async function editTransfer() {
    if (validateTransfer(newTransfer, items, setIsError, "edit")) {
      newTransfer.attachments = fileList
      const response = await updateTransfer(newTransfer, items);
      if (response.data) {
        toast.success(response.data.message, { style: toastStyle() });
        setTimeout(() => {
          navigate("/transfers/view/" + id + "/" + type);
        }, 1000);
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data);
        })
      }
    } else {
      toast.error("Please fill in all required fields", {
        style: toastStyle(),
      });
    }
  }

  async function fetchTransfer() {
    const response = await getTransfer(id);

    if (response.data) {
      var data = response.data.data[0];
      setNewTransfer({
        transfer_id: data.id,
        transfer_date: data.transfer_date,
        transfer_number: data.transfer_number,
        branch_to: data.branch_to,
        branch_from: data.branch_from,
        remarks: data.remarks,
        status: data.status,
        dispatcher: data.dispatcher,
      });
      setEmployeeValue({
        name: "dispatcher",
        label: data.dispatcher_name,
        value: data.dispatcher,
      });
      var itemEntries = data.transfer_items;
      var itemList = itemEntries.map((entry) => {
        var info = {};
        info.name = "item_id";
        info.value = entry.item_id;
        info.label = entry.item_name;
        info.item_id = entry.item_id;
        info.is_old_item = true;
        info.item_id_value = {
          name: "item_id",
          value: entry.item_id,
          label: entry.item_name,
        };
        info.units = entry.unit;
        info.item_unit_id = entry.item_unit_id;
        info.unit_value = entry.unit + "|" + entry.item_unit_id;
        info.prices = entry.price;
        info.quantities = entry.qty;
        return info;
      });
      setItems(itemList);
      var fromInfo = {};
      fromInfo.name = "branch_from";
      fromInfo.label = data.branch_from_name;
      fromInfo.value = data.branch_from;
      setBranchFromValue(fromInfo);
      var toInfo = {};
      toInfo.name = "branch_to";
      toInfo.label = data.branch_to_name;
      toInfo.value = data.branch_to;
      setBranchToValue(toInfo);
      // fetchAllItems(data.branch_from, itemList);
      
      
    }
  }

  async function fetchRequest() {
    const response = await getRequest(id);
    if (response.data) {
      var data = response.data.data[0];
      setNewTransfer({
        request_id: data.id,
        transfer_date: Moment().format("YYYY-MM-DD"),
        transfer_number: data.transfer_number,
        branch_to: data.branch_to,
        branch_from: data.branch_from,
        remarks: data.remarks,
        status: data.status,
        dispatcher: data.dispatcher,
      });
      setEmployeeValue({
        name: "dispatcher",
        label: data.dispatcher_name,
        value: data.dispatcher,
      });
      var itemEntries = data.request_items;
      var itemList = itemEntries.map((entry) => {
        var info = {};
        info.name = "item_id";
        info.value = entry.item_id;
        info.is_old_item = true
        info.label = entry.item_name;
        info.item_id = entry.item_id;
        info.item_id_value = {
          name: "item_id",
          value: entry.item_id,
          label: entry.item_name,
        };
        info.units = entry.unit;
        info.item_unit_id = entry.item_unit_id;
        info.unit_value = entry.unit + "|" + entry.item_unit_id;
        info.prices = entry.price;
        info.quantities = entry.qty;
        return info;
      });
      setItems(itemList);
      var fromInfo = {};
      fromInfo.name = "branch_from";
      fromInfo.label = data.branch_from_name;
      fromInfo.value = data.branch_from;
      setBranchFromValue(fromInfo);
      var toInfo = {};
      toInfo.name = "branch_to";
      toInfo.label = data.branch_to_name;
      toInfo.value = data.branch_to;
      setBranchToValue(toInfo);
      // fetchAllItems(data.branch_from, itemList);
    } else if (response.error) {
      toast.error(response.error.data.messages.error, {
        style: toastStyle(),
      });
    }
  }

  async function saveRequest() {
    if (isClicked) {
      return;
    }
    if (validateTransfer(newTransfer, items, setIsError, "add")) {
      newTransfer.attachments = fileList
      const response = await createTransfer(newTransfer, items);
      if (response.data) {
        const response2 = await changeRequestStatus(id, "processing");
        if (response2.data) {
          toast.success("Successfully created transfer!", {
            style: toastStyle(),
          });
          setTimeout(() => {
            navigate("/transfers");
          }, 1000);
        } else if (response2.error) {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data);
          })
          setTimeout(() => {
            navigate("/requests");
          }, 1000);
        }
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data);
        })
      }
    }
  }

  function handleSubmit() {
    if (add) saveTransfer();
    if (request) saveRequest();
    if (edit) {
      editTransfer();
    }
  }

  // to filter item options and set unit dropdown values per item
  function handleSetItemUnitOption(items, item_options) {

    var itemList = items?.map((item) => {
      var info = item
      var units = item_options?.filter((data) => data.value === item.value)
      info.item_units = units[0]?.item_units
      return info
    })
    setItems(itemList)
    
    // const filteredOptions = item_options.filter(option => {
    //   return !items.find(item => item.value === option.value);
    // });
    // setFilteredItemOptions(filteredOptions);
  }

  useEffect(() => {
    if (edit) {
      fetchAllEmployees();
      fetchTransfer();
      fetchBranches();
    }
    if (request) {
      fetchAllEmployees();
      fetchRequest();
      fetchBranches();
    }
  }, []);

  useEffect(() => {
    if (state) {
      setBranchFromValue({
        name: "branch_from",
        label: state.from_branch_name,
        value: state.from_branch_id,
      });

      // fetchAllItems(state.from_branch_id);
      setBranchToValue({
        name: "branch_to",
        label: state.to_branch_name,
        value: state.to_branch_id,
      });
      setNewTransfer((prev) => {
        return {
          ...prev,
          branch_from: state.from_branch_id,
          branch_to: state.to_branch_id,
        };
      });

      var requestedItems = state.purchased_items.map((item) => {
        var info = {};
        info.entry = {
          name: "item_id",
          value: item?.item_id,
          label: item?.item_name,
        };
        info.quantities = "0";
        info.units = item.unit_to_name;
        info.current_qty = item?.current_qty;

        return info;
      });
      setItems(requestedItems);
    }
  }, []);

  //DISABLE SCROLL FUNCTION
  function limitScroll() {
    var numericInputs = document.querySelectorAll(".numeric-input");
    numericInputs.forEach(function (input) {
      input.addEventListener("wheel", function (e) {
        e.preventDefault();
      });
    });
  }
  limitScroll();


  const handleBeforeUpload = (file) => {
    setFileList([...fileList, file]);
    return false;
  };

  const handleRemove = (selectedFile) => {
    var newlist = fileList.filter((file) => {
        return selectedFile.uid !== file.uid;
    });
    setFileList(newlist);
  };


  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"TRANSFERS"}
        />
      </div>
      <div
        className={`manager-container ${
          inactive ? "inactive" : "active"
        }`}
      >
        <Row className="mb-4">
          <Col xs={12} lg={8}>
          {add ? (
            <h1 className="page-title ps-2 ms-2 ms-md-0 ps-md-0 ms-md-0 fs-2">
              ADD TRANSFER {destination === ""}
            </h1>
          ) : request ? (
            <h1 className="page-title ps-2 ms-2 ms-md-0 ps-md-0 ms-md-0 fs-2">
              ADD TRANSFER {destination === ""}
            </h1>
          ) : (
            <h1 className="page-title ps-2 ms-2 ms-md-0 ps-md-0 ms-md-0 fs-2">
              EDIT TRANSFER {destination === ""}
            </h1>
          )}
          </Col>
        </Row>

        {/* FORM */}

        <div className="edit-form">
          <Fragment>
            <Row className="mb-3">
              <Col xs={12} lg={3}>
              <span className="nc-modal-custom-row uppercase">
                  Transfer Date
                  <label className="badge-required">{` *`}</label>
                </span>
                <Form.Control
                  type="date"
                  name="transfer_date"
                  defaultValue={newTransfer.transfer_date}
                  className="react-select-container"
                  onChange={(e) => handlePayChange(e)}
                />
                <InputError
                  isValid={isError.transfer_date}
                  message={"Transfer Date is required"}
                />
              </Col>
              <Col xs={12} lg={3} className="mt-4 mt-lg-0">
              <span className="nc-modal-custom-row uppercase">
                  transfer slip no.
                  <label className="badge-required">{` *`}</label>
                </span>
                <Form.Control
                  type="number"
                  name="transfer_number"
                  defaultValue={newTransfer.transfer_number}
                  className="react-select-container"
                  onChange={(e) => handlePayChange(e)}
                />
                <InputError
                  isValid={isError.transfer_number}
                  message={"Transfer Number is required"}
                />
              </Col>
              <Col xs={12} lg={3} className="mt-4 mt-lg-0">
              <span className="nc-modal-custom-row uppercase">
                  From
                  <label className="badge-required">{` *`}</label>
                </span>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Branch..."
                  value={branchFromValue}
                  options={branchFrom}
                  onChange={(e) => handleSelectChange(e)}
                />
                <InputError
                  isValid={isError.branch_from}
                  message={"Branch From is required"}
                />
              </Col>
              <Col xs={12} lg={3} className="mt-4 mt-lg-0">
              <span className="nc-modal-custom-row uppercase">
                  To
                  <label className="badge-required">{` *`}</label>
                </span>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Branch..."
                  value={branchToValue}
                  options={branchTo}
                  onChange={(e) => handleSelectChange(e)}
                />
                <InputError
                  isValid={isError.branch_to}
                  message={"Branch To is required"}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} lg={4}>
              <span className="nc-modal-custom-row uppercase">
                  Dispatcher
                </span>
                <Select
                  name="dispatcher"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Dispatcher..."
                  value={employeeValue}
                  options={employeeOptions}
                  onChange={(e) => handleSelectChange(e)}
                />
              </Col>
              <Col xs={12} lg={8} className="mt-4 mt-lg-0">
              <span className="nc-modal-custom-row uppercase">
                  Remarks
                  <span className="edit-optional px-2">(Optional)</span>
                </span>
                <Form.Control
                  type="text"
                  name="remarks"
                  defaultValue={newTransfer.remarks}
                  className="react-select-container"
                  onChange={(e) => handlePayChange(e)}
                />
              </Col>
            </Row>
          </Fragment>

          {/* INVOICES */}
          <div className="mt-4 pt-3 d-flex flex-column">
            <span className="nc-modal-custom-row mb-2 uppercase">
              LIST OF ITEMS TO TRANSFER{" "}
              <label className="badge-required">{` *`}</label>
            </span>

            <Container fluid className="edit-purchased-items">
              {items.length === 0 ? (
                <div className="entries-not-found">
                  {add && "You haven't added any items yet."}
                  {edit && "Items not found."}
                </div>
              ) : (
                <>
                  {renderTable()}
                  {/* {edit && <>{renderTableEdit()}</>}
                  {!edit && <>{renderTable()}</>} */}
                </>
              )}
            </Container>
            <Row className="my-2 align-right pb-2 align-items-start">
              <Col className="pt-3 PO-add-item">
                <Button type="button" onClick={() => AddItem()}>
                  Add Item
                </Button>
              </Col>
            </Row>
            <Row className="mt-4 mb-2">
              <Col>
                <span className="edit-label">File Attachment</span>
                <Dragger
                    {...{
                    // style: { width: 550 },
                    file,
                    defaultFileList: file,
                    onRemove: handleRemove,
                    beforeUpload: handleBeforeUpload,
                    multiple: false,
                    // onChange: handleOnChange,
                    listType: "picture",
                    progress: { showInfo: true },
                    }}
                >
                    <img
                        alt="upload"
                        src={upload}
                        className="cursor-pointer"
                    />
                    <p className="ant-upload-text">
                        Click or drag file to this area to upload
                    </p>
                </Dragger>
              </Col>
            </Row>
          </div>

          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-secondary me-3"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            {isClicked ? (
              <div className="button-primary me-3 d-flex justify-content-center">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={50}
                  width={50}
                />
              </div>
            ) : (
              <button
                type="button"
                className="button-primary"
                onClick={handleSubmit}
              >
                Save
              </button>
            )}
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
}

FormTransfer.defaultProps = {
  add: false,
  edit: false,
};

export default FormTransfer;
